import { connect } from "react-redux";
import SurveyStepActionKpiTab from "./SurveyStepActionsKpiTab";
import addStepSurvey from "./../../../../../redux/actions/surveyActions";
import {
	getActionTypes,
	getKpisList,
} from "../../../../../redux/selectors/survey/createSelector";
import { updateStatementActions } from "../../../../../redux/actions/surveyActions";
import _ from "lodash";
import LocationType from "../LocationType";

const mapStateToProps = (state, ownProps) => {
	const surveyProgress = state.survey.surveyManager.surveyProgress;
	const locationTypes = surveyProgress.locationTypes || [];
	const locationTypeDataIndex = _.findIndex(locationTypes, {
		locationTypeId: ownProps.locationType.locationTypeId,
	});
	const locationTypeData =
		locationTypeDataIndex !== -1 ? locationTypes[locationTypeDataIndex] : {};
	const locationType = new LocationType(locationTypeData);
	const currentStatements = locationType.statements;

	let nbActionTypes = 0;
	for (let i = 0; i < currentStatements.length; i++) {
		const currentStatement = currentStatements[i];
		currentStatement.actions = currentStatement.actions || [];
		nbActionTypes += currentStatement.actions.length || 0;
	}
	return {
		actionTypes: getActionTypes(state),
		kpisList: getKpisList(state),
		actionsList: state.survey.surveyManager.actionsList || [],
		location: ownProps.locationType,
		currentStatements,
		nbActionTypes: nbActionTypes,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		updateStatementActions: (locationType, statement, action, checked) => {
			dispatch(
				updateStatementActions(locationType, statement, action, checked)
			);
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SurveyStepActionKpiTab);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTab/SurveyStepActionsKpiTabContainer.js